import Http from '@/services/http';
import UploadFacade from '@/services/tus/UploadFacade';
import { AssetFilesDetails, File } from 'sigma-mappings';

const urls = {
  postFile: assetId => `/informacoes-ativos/arquivos?ativoId=${assetId}`,
  getFiles: assetId => `/ativo/${assetId}/arquivos`,
  getFilesDetails: assetId => `/ativo/${assetId}/arquivos/detalhes`,
  deleteFile: (assetId, fileId) => `/ativo/${assetId}/arquivos/${fileId}`,
  downloadFile: (assetId, fileId) => `/ativo/${assetId}/arquivos/${fileId}/download`,
};

const uploadErrorMessageParams = details => ({
  $ME017: { allowedExtensionList: details.allowedExtensions },
  $ME019: { allowedSize: details.maxFileSize },
  $ME020: { allowedSize: details.maxAssetSize },
  $ME049: {},
});

export default {
  createUploadManager(assetId, details, { listeners, listenersScope }) {
    return new UploadFacade({
      url: urls.postFile(assetId),
      listeners,
      listenersScope,
      errorHandling: {
        responseMessageParams: uploadErrorMessageParams(details),
      },
    });
  },
  getFiles(assetId) {
    const http = new Http();
    return http
      .get(urls.getFiles(assetId))
      .then(({ data }) => data.map(item => new File(item)));
  },
  getFilesDetails(assetId) {
    const http = new Http();
    return http
      .get(urls.getFilesDetails(assetId))
      .then(({ data }) => new AssetFilesDetails(data));
  },
  deleteFile(assetId, fileId) {
    const http = new Http();
    return http
      .delete(urls.deleteFile(assetId, fileId))
      .then(({ data }) => data);
  },
  downloadFile(assetId, fileId) {
    const http = new Http({ download: true });
    return http
      .get(urls.downloadFile(assetId, fileId))
      .then(({ data }) => data);
  },
};
